/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import {createSelector} from 'reselect';
import {selectInitializationComplete} from './initialization';
import {selectAuthenticated} from './login';

export type LoginSelectorType = {
  authenticated: boolean;
  isInitialized: boolean;
}

//output
export const isValidLoginSelector = createSelector([
  selectAuthenticated,
  selectInitializationComplete
], (authenticated, isInitialized): LoginSelectorType => ({
  authenticated,
  isInitialized
}));
